import { render, staticRenderFns } from "./CadastrarEditarAnoLetivoDialog.vue?vue&type=template&id=aceadb22"
import script from "./CadastrarEditarAnoLetivoDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarAnoLetivoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports